import { ReactNode } from "react";

import { CircleDisabledIcon, PersonSingleIcon, PersonStatusIcon } from "mds/icons";
import type { IconProps } from "mds/utils/images";
import { SectionUserActivityStatus } from "store/selectors";

export const getUserActivityIcon = (
  status: SectionUserActivityStatus | "disabled",
  size: IconProps["size"] = "m",
) => {
  switch (status) {
    case SectionUserActivityStatus.ACTIVE:
    case SectionUserActivityStatus.INACTIVE:
      return <PersonStatusIcon size={size} statusColor="green" />;
    case SectionUserActivityStatus.OFFLINE:
      return <PersonSingleIcon size={size} />;
    case "disabled":
      return <CircleDisabledIcon size={size} />;
    default:
      return null;
  }
};

export const userActivityIcons: Record<SectionUserActivityStatus | "disabled", ReactNode> = {
  active: getUserActivityIcon(SectionUserActivityStatus.ACTIVE),
  inactive: getUserActivityIcon(SectionUserActivityStatus.INACTIVE),
  offline: getUserActivityIcon(SectionUserActivityStatus.OFFLINE),
  disabled: getUserActivityIcon("disabled"),
};

export const isUserOnline = (status: SectionUserActivityStatus) =>
  status === SectionUserActivityStatus.ACTIVE || status === SectionUserActivityStatus.INACTIVE;
